import type { LayerId } from 'cadenza/workbook/api/layer-id';
import type { DataViewId } from 'cadenza/workbook/model/data-view-id';

/**
 * The data layers in map views and the data views share the same ID.
 * Sometimes we need to do things such as looking up a data view using a layer ID.
 * This function is used to convert from one ID type to the other without type assertion.
 * @param layerId
 */
export function toDataViewId(layerId: LayerId): DataViewId {
  return layerId as string as DataViewId;
}
